/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {NgModule} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import { DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule, ButtonModule, TabViewModule } from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';

import {SearchModule} from "../../component/search.component";

import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {DatePipe, CommonModule} from "@angular/common";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Logger} from "angular2-logger/core"; // ADD THIS
import {ExDialogModule} from "../../component/dialog.component";
import { AuditLog } from '../../model/auditlog';
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {DomSanitizer} from '@angular/platform-browser';
import {BrowserDomAdapter} from '@angular/platform-browser/src/browser/browser_adapter';
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";




@Component({

  selector: 'dbSync',
  templateUrl: 'dbSync_log.html'
})
export class DBSyncLogComponent implements OnInit {
  @ViewChild("differ") el:ElementRef;
  @ViewChild("sp") sp_el:ElementRef

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  excelIsTrue : boolean = true;
  insaSyncIsUse : boolean = true;
  sDate: string;
  eDate: string;
  isLike : string;

  // company_items : SelectItem[];
  // visitorType_items : SelectItem[];
  operation_items : SelectItem[];
  entityName_items : SelectItem[];
  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  addTitle : string = "자세히";
  addShow : boolean = false;
  addDialogWidth : number = 700
  selectLog : AuditLog;
  selecthPolicy : any;
  selecthCondition : any[] = [];
  selecthControl : any[] = [];

  auditPolicyShow : boolean = false;
  pre_id : number;
  next_id : number;
  appointedTitle : string = "";
  private translate:TranslateServiceForm;

  title : string;
  dialogWidth : any;
  detailShow : boolean ;
  detailSelected : any;

  ngOnInit() {
    this.searchTextIsUse = false;
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd')
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd')
    this.getDBSyncLogList(0, 10, '', '', this.sDate, this.eDate);
    
  }

  constructor(private domAdapter : BrowserDomAdapter, private service : MamAdminService, private _translate: TranslateServiceForm, private logger : Logger, private sanitizer : DomSanitizer) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.dateIsTrue = true;
    this.excelIsTrue = false;

  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }

    this.getDBSyncLogList(0,this.pageMax,this.searchText, this.searchId, this.sDate, this.eDate);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getDBSyncLogList(event.page, event.rows,this.searchText, this.searchId, this.sDate, this.eDate);
    } else {
      this.getDBSyncLogList(event.page, event.rows,"", "", this.sDate, this.eDate);
    }

  }

  getDBSyncLogList(page:number, max:number, search:string, field:string, start:string, end:string) {
    this.service.getDBSyncLogList(page, max, search, field, start, end).subscribe(
        value => {
          console.log(value.content);
          this.logger.debug("get db sync list : " , value.content);
          this.table_list = value.content;
          this.totalRecord = value.totalElements;
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )
  }

  startSync(type:string, createDate:any) {
    let date = "";
    if(createDate != null){
      date = this.datePipe.transform(createDate, 'yyyyMMdd');
    }

    this.service.startDBSync(type,date).subscribe(
      value => {
        console.log("==============> start Sync");

        if(value.fail){
          alert("인사연동에 실패했습니다.");
        }else{
          alert("인사연동이 완료되었습니다.");
        }
        this.getDBSyncLogList(0, 10, '', '', this.sDate, this.eDate);

      },
      error => {

      },
    )
  }

  searchTextChange(data) {
    this.searchText = '';
    if(data == 'entityName') {
      this.searchTextDropBox = this.entityName_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'operation') {
      this.searchTextDropBox = this.operation_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'all' || !data) {
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = false;
    } else {
      this.searchTextIsUse = true;
      this.searchTextIsDropBox = false;
    }

  }
  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    var url = this.service.getUrl() + "/mgr/log/audit/excel";
    if(!this.searchId || this.searchId == "all") {
      url = url + "?start=" + this.sDate + "&end=" + this.eDate;
    } else{
      url = url + "?start=" + this.sDate + "&end=" + this.eDate +
      "&search_text=" + this.searchText + "&search_field=" + this.searchId;
    }

    window.open(url);
  }

  
  

  selectLogDetail(data) {
    this.logger.debug("data :" , data);
     var pre_el = document.createElement('table');
     var next_el = document.createElement('table');
     pre_el.innerHTML = data.originalEntityView;
     next_el.innerHTML = data.differenceView;
     var pre_dom = this.domAdapter.getElementsByClassName(pre_el,"audit-detail")[0];
     var next_dom = this.domAdapter.getElementsByClassName(next_el,"audit-detail")[0];
     this.logger.debug("pre dom : " , pre_dom);
     this.logger.debug("next dom : " , next_dom);
     if(pre_dom && next_dom) {
        this.pre_id = Number(this.domAdapter.attributeMap(pre_dom).get('historyid'));
        this.next_id = Number(this.domAdapter.attributeMap(next_dom).get('historyid'));
        this.logger.debug("pre policy id :", this.pre_id);
        this.logger.debug("next policy id :", this.next_id);
     } else {
       this.pre_id = 0;
       this.next_id = 0;
     }

    //  this.getGroupTarget(this.historyPolicyId);
    //  this.getPolicyTargetList(this.historyPolicyId, "device", 0, 999);
    // data.originalEntityView = this.sanitizer.bypassSecurityTrustHtml(data.originalEntityView);
    // data.differenceView = this.sanitizer.bypassSecurityTrustHtml(data.differenceView);
    setTimeout(() => {
      this.selectLog = data;
      this.addShow = true;
    } , 200);


  }
  selectDetailInfo(item){
    console.log("item",item);
    //this.logger.debug("item",item);
    this.title = this.translate.instant('LANG_Detail');
    this.dialogWidth = '600px';
    this.detailShow = true;
    this.detailSelected = item;
    this.logger.debug("detail Selected " ,this.detailSelected);
  }

  confirm(event){
    this.detailShow = false;
  }


}

@NgModule({
  imports: [ExDialogModule, ButtonModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule, SearchDropBoxModule, MainPipeMoudle, TabViewModule, TranslatePipeMoudle],
  exports: [DBSyncLogComponent],
  declarations: [DBSyncLogComponent],
  providers: [MamAdminService, BrowserDomAdapter],
})
export class DBSyncLogModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/dbSync_log.ts